import Swiper, {Navigation} from 'swiper';
Swiper.use([Navigation]);

(function($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */

	const initializeBlock = $block => {
		const container = $block.find('.swiper-container').get(0);
		const swiper = new Swiper(container, {
			direction: 'horizontal',
			slidesPerView: 'auto',
			spaceBetween: 32,
			navigation: {
				nextEl: $block.find('.swiper-button-next').get(0),
				prevEl: $block.find('.swiper-button-prev').get(0)
			}
		});
	};

	// Initialize each block on page load (front end).
	$(document).ready(() => {
		$('.wp-block-image-carousel').each((i, el) => {
			initializeBlock($(el));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=image-carousel', initializeBlock);
	}
})(jQuery);